import ChangeCase from 'change-case'

export const convertToGroup = (activity, type) => ({
  key: activity.id,
  type,
  from: activity.from,
  timestamp: activity.timestamp,
  boardId: activity.data.boardId,
  boardName: activity.data.boardName,
  cardId: activity.data.cardId,
  cardName: activity.data.cardName,
  activities: [
    activity
  ]
})

export const mapActivityData = (Activity) => {
  const Message = JSON.parse(Activity.JsonMessage)

  let message = {}

  Object.keys(Message).forEach(key => {
    const newKey = ChangeCase.camelCase(key)

    let value
    try {
      value = JSON.parse(Message[key])
    } catch (error) {
      value = Message[key]
    }

    message[newKey] = value
  })

  const activity = {
    id: Activity.Id,
    from: Activity.From,
    tags: Activity.Tags,
    timestamp: Activity.Timestamp,
    data: {
      ...message
    }
  }

  if (typeof Activity.IsBookmarked !== 'undefined') {
    activity.isBookmarked = Activity.IsBookmarked
  }

  return activity
}

export const getIconName = (action) => {
  switch (action) {
    case 'AddUserToCard':
    case 'AddToGroup':
    case 'AddUserToGroup':
    case 'AddUserToBoard':
      return 'kanbo-16-set-responsible'
    case 'RemoveUserFromCard':
    case 'RemoveFromGroup':
    case 'RemoveUserFromGroup':
    case 'RemoveUserFromBoard':
      return 'kanbo-16-remove-responsible'
    case 'MakeUserResponsible':
      return 'kanbo-16-solid-star'
    case 'AddDocumentToCard':
    case 'AddDocumentsListItem':
    case 'RemoveDocumentsListItem':
    case 'EventDocumentRemove':
    case 'EventDocumentAdd':
    case 'EventDocumentUpdate':
      return 'kanbo-16-document'
    case 'SetDueDate':
    case 'AlarmDueDate':
    case 'AlarmDueDateChildCard':
    case 'AlarmDueDatePredecessorCard':
      return 'kanbo-16-due-date'
    case 'SetStartDate':
    case 'AlarmStartDate':
      return 'kanbo-16-start-date'
    case 'AddCustomDate':
    case 'SetCustomDate':
    case 'AlarmCustomDate':
      return 'kanbo-16-card-date'
    case 'AlarmPersonalDate':
      return 'kanbo-16-personal-reminder'
    case 'RemoveDueDate':
    case 'RemoveStartDate':
    case 'RemoveCustomDate':
      return 'kanbo-16-remove-due-date'
    case 'AddChecklistItem':
    case 'AddChecklist':
    case 'AddNote':
    case 'AddDocumentsList':
    case 'AddDocumentsFolder':
    case 'AddDocumentsFolderCreator':
    case 'AddSubCardGroup':
      return 'kanbo-16-plus'
    case 'RemoveElement':
    case 'RemoveChecklistItem':
      return 'kanbo-16-remove'
    case 'CompleteChecklistItem':
      return 'kanbo-16-solid-check-box-checked'
    case 'UncompleteChecklistItem':
      return 'kanbo-16-check-box-unchecked'
    case 'AddCardStatus':
    case 'RemoveCardStatus':
    case 'SetCardStatus':
      return 'kanbo-16-in-process'
    case 'MoveCard':
    case 'ChangeCardParent':
    case 'ConvertChecklistItemToCard':
      return 'kanbo-16-convert-to-card'
    case 'RenameCard':
    case 'RenameList':
    case 'RenameBoard':
    case 'RenameChecklistItem':
    case 'RenameElement':
    case 'RenameLabel':
    case 'RenameCustomDate':
    case 'RenameCardStatus':
      return 'kanbo-16-letter-count'
    case 'AddLabel':
    case 'AddLabelToCard':
    case 'RemoveLabelFromCard':
    case 'RemoveLabel':
      return 'kanbo-16-label'
    case 'ChangeNoteContent':
      return 'kanbo-16-note'
    case 'AddCardParent':
    case 'RemoveCardParent':
    case 'AddCardSuccessor':
    case 'RemoveCardSuccessor':
      return 'kanbo-16-subcard'
    case 'ArchiveCard':
    case 'UnarchiveCard':
    case 'ArchiveCardsInList':
    case 'ArchiveCardsInStatus':
    case 'ArchiveCardsWithLabel':
    case 'ArchiveCardsWithUser':
      return 'kanbo-16-archive'
    case 'CopyCard':
      return 'kanbo-16-copy-card'
    case 'CopyBoard':
      return 'kanbo-16-copy-board'
    case 'AddUserToHomeLayout':
    case 'RemoveUserFromHomeLayout':
    case 'ChangeUserPermissionLevelInHomeLayout':
      return 'kanbo-16-desk'
    case 'AddBoardTemplate':
    case 'ApplyBoardTemplate':
    case 'AddCardTemplate':
    case 'ApplyCardTemplate':
      return 'kanbo-16-template'
    case 'PredecessorCardCompleted':
    case 'SubCardCompleted':
      return 'kanbo-16-completed-inactive'
    case 'AddBlockerToCard':
    case 'AddBlockerToChildCard':
    case 'AddBlockerToPredecessorCard':
    case 'ChangeCardBlockerReason':
    case 'ChangeCardBlockerUser':
      return 'kanbo-16-block'
    case 'RemoveBlocker':
    case 'RemoveBlockerFromCard':
    case 'RemoveBlockerFromChildCard':
    case 'RemoveBlockerFromPredecessorCard':
      return 'kanbo-16-unblock'
    default:
      return 'kanbo-16-stream'
  }
}
